import { authRoles } from 'app/auth';
import React from 'react';

const DpLinkPageConfig = {
	settings: {
		layout: {
		  config: {},
		},
	  },
	routes: [
		{
			path: '/dp-link',
			component: React.lazy(() => import('./DpLink'))
		}
	]
};

export default DpLinkPageConfig;
